(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
(() => {
  const path = location.pathname.split('/').filter(Boolean);
  if (path.at(-2) !== 'collections' || !['cabinet-knobs', 'cabinet-pulls'].includes(path.at(-1))) return;
  const labels = {
    snize_filters_block_filter_option_a20ddccbb6f808ec42cd66323e6c6061: 'Color Group',
    snize_filters_block_filter_option_a0c439bf7ed19f207869f0e9f181eb31: 'Center to Center',
    snize_filters_block_snize_facet2: 'Finish'
  };
  const updateLabels = () => {
    Object.entries(labels).forEach(([id, label]) => {
      document.querySelectorAll('[id="' + id + '_title"]').forEach(title => {
        if (title.textContent !== label) title.textContent = label;
        const button = title.closest('button[aria-label]');
        if (button && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
    });
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; updateLabels(); });
  }).observe(document.body, {childList: true, subtree: true});
  updateLabels();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-cabinetry-product"] && !Shopify.designMode) return;
  try {
    
function setupCabinetry(root){if(root.dataset.cabReady)return;root.dataset.cabReady='true';root.querySelectorAll('[data-cab-image]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('.rok-cab__slide').forEach(slide=>{slide.hidden=slide.id!==button.dataset.cabImage});root.querySelectorAll('[data-cab-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)))}));const select=root.querySelector('[data-cab-variant]');if(select)select.addEventListener('change',()=>{root.querySelector('[data-cab-price]').textContent=select.selectedOptions[0].dataset.price;root.querySelector('[data-cab-prop65]').innerHTML=select.selectedOptions[0].dataset.prop65||''})}document.querySelectorAll('.rok-cab').forEach(setupCabinetry);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.rok-cab').forEach(setupCabinetry));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-compatible-accessories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rok-compatible-accessories')) {
  customElements.define('rok-compatible-accessories', class extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = event => {
        if (event.target.closest('section[data-product-handle]')?.dataset.productHandle !== this.dataset.productHandle) return;
        this.renderVariant(event.target.currentVariant?.id);
      };
      document.addEventListener('variantChangeEnd', this.onVariantChange);
      this.renderVariant(this.dataset.initialVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('variantChangeEnd', this.onVariantChange);
    }
    renderVariant(id) {
      const template = Array.from(this.querySelectorAll('template[data-compatible-variant]')).find(el => el.dataset.compatibleVariant === String(id));
      const cards = this.querySelector('[data-compatible-cards]');
      cards.replaceChildren();
      if (template) cards.append(template.content.cloneNode(true));
      this.hidden = !cards.querySelector('a');
      this.querySelector('[data-compatible-model]').textContent = template?.dataset.model || '';
      const note = this.querySelector('p[data-compatible-note]');
      note.textContent = template?.dataset.compatibleNote || '';
      note.hidden = !note.textContent;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-faq"] && !Shopify.designMode) return;
  try {
    
function initRokFaq(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const items=Array.from(root.querySelectorAll('[data-question]')),input=root.querySelector('input[type=search]'),categories=root.querySelector('[data-categories]'),expand=root.querySelector('[data-expand]');
 let category='';
 const normalize=s=>s.toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g,' ').trim();
 items.forEach(el=>el.dataset.search=normalize(el.textContent));
 [...new Set(items.map(el=>el.dataset.topic))].forEach(name=>{const b=document.createElement('button');b.type='button';b.textContent=name;b.dataset.category=name;b.setAttribute('aria-pressed','false');categories.append(b)});
 const visible=()=>items.filter(el=>!el.hidden);
 function label(){expand.textContent=visible().length&&visible().every(el=>el.open)?expand.dataset.collapseLabel:expand.dataset.expandLabel}
 function filter(){const terms=normalize(input.value).split(' ').filter(Boolean);items.forEach(el=>{el.hidden=!!(category&&el.dataset.topic!==category)||!terms.every(t=>el.dataset.search.includes(t));if(terms.length&&!el.hidden)el.open=true});root.querySelectorAll('[data-group]').forEach(el=>el.hidden=!visible().some(q=>q.dataset.topic===el.dataset.group));root.querySelector('[data-count]').textContent=visible().length;root.querySelector('[data-empty]').hidden=visible().length>0;label()}
 categories.addEventListener('click',e=>{const b=e.target.closest('[data-category]');if(!b)return;category=b.dataset.category;categories.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));filter()});
 input.addEventListener('input',filter);root.querySelector('[data-clear]').addEventListener('click',()=>{input.value='';filter();input.focus()});
 expand.addEventListener('click',()=>{const open=!visible().every(el=>el.open);visible().forEach(el=>el.open=open);label()});items.forEach(el=>el.addEventListener('toggle',label));
 function hash(){const target=items.find(el=>'#'+el.id===location.hash);if(target){category='';input.value='';categories.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(!b.dataset.category)));filter();target.open=true;target.scrollIntoView({block:'start'})}}
 root.querySelectorAll('[data-tools]').forEach(el=>el.hidden=false);filter();hash();window.addEventListener('hashchange',hash);
}
document.querySelectorAll('[data-rok-faq]').forEach(initRokFaq);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-rok-faq]').forEach(initRokFaq));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-hinge-pilot"]) return;
  try {
    
if(!customElements.get('rok-hinge-family'))customElements.define('rok-hinge-family',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.config=JSON.parse(this.querySelector('[data-config]').textContent);this.item=this.config.items.find(x=>String(x.id)===this.dataset.current)||this.config.items[0];if(!this.item)return;this.querySelectorAll('input[type=radio]').forEach(el=>el.addEventListener('change',()=>{const app=el.name.startsWith('application-')?el.value:this.item.application;const method=el.name.startsWith('method-')?el.value:this.item.method;this.item=this.config.items.find(x=>x.application===app&&x.method===method)||this.config.items.find(x=>x.application===app);this.render()}));this.querySelector('[data-qty]').addEventListener('input',()=>this.quantity());this.querySelector('[data-add]').addEventListener('click',()=>this.add());this.querySelector('.rhf-thumbs').addEventListener('click',e=>{const b=e.target.closest('[data-photo]');if(b)this.photo(b.dataset.photo)});this.render()}
money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.config.currency||'USD'}).format(n/100)}
photo(url){const img=this.querySelector('.rhf-hero');img.src=url;img.removeAttribute('srcset');img.alt=this.config.text.photo+' '+this.item.sku}
render(){const i=this.item,$=s=>this.querySelector(s);this.querySelectorAll('input[name^="application-"]').forEach(el=>el.checked=el.value===i.application);this.querySelectorAll('[data-method]').forEach(label=>{const el=label.querySelector('input');label.hidden=!this.config.items.some(x=>x.application===i.application&&x.method===el.value);el.disabled=label.hidden;el.checked=el.value===i.method});const accessories=this.querySelector('[data-accessories]');if(accessories){let count=0;accessories.querySelectorAll('[data-accessory-skus]').forEach(card=>{card.hidden=!card.dataset.accessorySkus.split(',').map(s=>s.trim()).includes(i.sku);if(!card.hidden)count++});accessories.hidden=count===0;}$('[data-prop65]').innerHTML=(i.prop65_html||'').replaceAll('<\\/','</');$('[data-sku]').textContent=i.sku;$('[data-mpn]').textContent=i.mpn;$('[data-price]').textContent=this.money(i.price);$('[data-list-price-wrap]').hidden=!(i.compare_at_price>0);$('[data-list-price]').textContent=i.compare_at_price>0?this.money(i.compare_at_price):'';$('[data-list-price]').style.textDecoration=i.compare_at_price>i.price?'line-through':'none';$('[data-arm]').textContent=i.arm;$('[data-method-help]').textContent=i.help;this.photo(i.images[0]);const wrap=$('.rhf-thumbs');wrap.replaceChildren();i.images.forEach((url,n)=>{const b=document.createElement('button');b.type='button';b.dataset.photo=url;b.setAttribute('aria-label',this.config.text.photo+' '+(n+1));const img=document.createElement('img');img.src=url;img.alt='';img.loading='lazy';b.append(img);wrap.append(b)});this.quantity()}
quantity(){const q=Number(this.querySelector('[data-qty]').value);this.valid=Number.isInteger(q)&&q>0;this.querySelector('[data-add]').disabled=!this.valid||!!this.busy;this.querySelector('[data-status]').textContent=this.valid?'':this.config.text.qty}
async add(){if(this.busy||!this.valid)return;this.busy=true;this.quantity();const b=this.querySelector('[data-add]');b.textContent=this.config.text.adding;try{const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:this.item.id,quantity:Number(this.querySelector('[data-qty]').value)}]})});if(!response.ok)throw new Error();window.location.assign(this.dataset.cart)}catch{this.busy=false;this.quantity();b.textContent=this.config.text.cart;this.querySelector('[data-status]').textContent=this.config.text.error}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-organizer-catalog"] && !Shopify.designMode) return;
  try {
    
function rokCornerInches(text) {
  return String(text).replace(/\b(\d+\.\d+)(?=\s*(?:"|″|inches\b|in\b))/g, (_, raw) => {
    const value=Number(raw), exact=Math.round(value*32);
    const units=Math.abs(exact/32-value)<0.00011 ? exact : Math.ceil(value*16)*2;
    const whole=Math.floor(units/32);let numerator=units%32, denominator=32;
    while(numerator && numerator%2===0){numerator/=2;denominator/=2;}
    return numerator ? (whole?whole+'-':'')+numerator+'/'+denominator : String(whole);
  });
}


if (!customElements.get('rok-organizer-catalog')) {
  customElements.define('rok-organizer-catalog', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-rok-variants]').textContent);
      this.salesStatus = JSON.parse(this.querySelector('[data-rok-sales-status]').textContent);
      this.fitCorrections = JSON.parse(this.querySelector('[data-rok-fit-corrections]')?.textContent || '{}');
      if (Object.keys(this.variants).length === 1) {
        const singlePicker = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"] variant-options');
        if (singlePicker) { singlePicker.hidden = true; singlePicker.style.display = 'none'; }
      }
      if (this.dataset.productHandle === 'rev-a-shelf-4ssb-pullout-produce-baskets') this.initializeProduceSelector();
      const selector = this.querySelector('[data-rok-model-selector]');
      this.selector = selector;
      if (selector) {
        const picker = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"] variant-options');
        if (picker) {
          picker.before(selector);
          picker.style.display = 'none';
          if (selector.querySelector('[data-rok-fit-selector]')) this.initializeFitSelector(selector, picker);
          selector.querySelector('[data-rok-legacy-selector] select').addEventListener('change', event => {
            const url = new URL(window.location.href);
            url.pathname = new URL(event.target.selectedOptions[0].dataset.modelUrl, location.origin).pathname;
            url.searchParams.set('variant', event.target.value);
            window.location.assign(url.toString());
          });
        }
      }
      this.initializeCatalogFit();
      this.initializeWctm();
      this.initializeMixer();
      this.initializePspe();
      const wasteChoices = this.querySelector('[data-waste-choices]');
      if (wasteChoices) {
        const main = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"]');
        const picker = main?.querySelector('variant-options');
        if (picker) {
          picker.before(wasteChoices);
          picker.hidden = true;
          picker.style.display = 'none';
          wasteChoices.hidden = false;
          const comparison = this.querySelector('[data-catalog-comparison]');
          if (comparison) comparison.hidden = true;
        }
      }
      this.onVariantChange = event => {
        const main = event.target.closest('section[data-product-handle]');
        if (main?.dataset.productHandle !== this.dataset.productHandle) return;
        this.renderVariant(event.target.currentVariant?.id);
      };
      document.addEventListener('variantChangeEnd', this.onVariantChange);
      this.renderVariant(this.dataset.initialVariant);
    }
    initializePspe() {
      const panel=this.querySelector('[data-pspe-selector]');if(!panel)return;
      const main=document.querySelector('section[data-product-handle="'+this.dataset.productHandle+'"]');
      const picker=main?.querySelector('variant-options');
      const anchor=picker || main?.querySelector('.rok-organizer-fit');if(!anchor)return;
      panel.querySelector('[data-pspe-model]').addEventListener('change',event=>location.assign(new URL(event.target.selectedOptions[0].dataset.url,location.origin).toString()));
      if(this.selector)this.selector.hidden=true;
      anchor.before(panel);if(picker)picker.style.display='none';panel.hidden=false;
    }
    initializeMixer() {
      const panel=this.querySelector('[data-mixer-selector]');
      if (!panel) return;
      const main=document.querySelector('section[data-product-handle="'+this.dataset.productHandle+'"]');
      const picker=main?.querySelector('variant-options');
      const anchor=picker || main?.querySelector('.rok-organizer-fit') || main?.querySelector('form[action="/cart/add"]');
      if (!anchor) return;
      const models=JSON.parse(panel.querySelector('[data-mixer-models]').textContent);
      const current=models.find(m=>m.id===this.dataset.initialVariant);
      if (!current) return;
      const packageSelect=panel.querySelector('[data-mixer-package]');
      const finish=panel.querySelector('[data-mixer-finish]');
      packageSelect.value=current.package;
      const detail=this.variants[current.id];
      if(current.package==='shelf' && detail){const opening=detail.specifications?.find(s=>s.label.startsWith('Required opening'));if(opening){detail.cabinet_recommendation=(opening.label.includes('frameless')?'18-inch frameless cabinet':'18-inch face-frame cabinet')+' · '+opening.value;detail.clear_opening=opening.value;}}

      const render=()=>{const available=models.filter(m=>m.package===packageSelect.value);finish.replaceChildren(...available.map(m=>new Option(m.label,m.id)));if(available.some(m=>m.id===current.id))finish.value=current.id;};
      const navigate=()=>{const model=models.find(m=>m.id===finish.value);location.assign(new URL(model.url,location.origin).toString());};
      packageSelect.addEventListener('change',()=>{render();navigate();});
      finish.addEventListener('change',navigate);
      main.querySelectorAll('h1').forEach(h=>h.textContent=panel.dataset.familyTitle);
      main.querySelectorAll('[data-rok-legacy-selector]').forEach(el=>el.hidden=true);
      const legacy=main.querySelector('.rok-model-selector');if(legacy)legacy.hidden=true;
      if(this.selector)this.selector.hidden=true;
      anchor.before(panel);if(picker)picker.style.display='none';panel.hidden=false;render();
    }
    initializeWctm() {
      const panel = this.querySelector('[data-wctm-selector]');
      if (!panel) return;
      const main = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"]');
      const picker = main?.querySelector('variant-options');
      if (!picker) return;
      const labels = JSON.parse(panel.querySelector('[data-wctm-labels]').textContent);
      const config = JSON.parse(panel.querySelector('[data-wctm-config]').textContent);
      const models = JSON.parse(panel.querySelector('[data-wctm-models]').textContent).map(m=>({...m,...config[m.mpn]}));
      if (models.some(m=>!m.types)) return;
      const current = models.find(m=>m.id === this.dataset.initialVariant);
      if (!current) return;
      main.querySelectorAll('h1').forEach(h=>h.textContent=panel.dataset.familyTitle);
      const fields = ['type','opening','bins','motion','wood'];
      const controls = Object.fromEntries(fields.map(k=>[k,panel.querySelector('[data-wctm-filter="'+k+'"]')]));
      const params = new URL(location.href).searchParams;
      const state = Object.fromEntries(fields.map(k=>[k,params.get('wctm_'+k) || '']));
      if (!params.has('wctm_type')) {state.type=current.types[0];state.opening=current.opening;}
      const label = (key,value) => key === 'opening' && value !== 'adjustable' ? value+'″' : labels[value] || value;
      const matches = (m,key,value) => !value || (key === 'type' ? m.types.includes(value) : m[key] === value);
      const results = panel.querySelector('[data-wctm-results]');
      const linkFor = model => {
        const url = new URL(model.url,location.origin);
        fields.forEach(k=>url.searchParams.set('wctm_'+k,state[k]));
        return url.pathname+url.search;
      };
      const render = () => {
        let available=models;
        fields.forEach(key=>{
          const values=[...new Set(available.flatMap(m=>key==='type'?m.types:[m[key]]))];
          if(key==='opening') values.sort((a,b)=>(parseFloat(a)||999)-(parseFloat(b)||999));
          if(!values.includes(state[key]))state[key]='';
          controls[key].replaceChildren(new Option(labels.all,''),...values.map(value=>new Option(label(key,value),value)));
          controls[key].value=state[key];
          available=available.filter(m=>matches(m,key,state[key]));
        });
        panel.querySelector('[data-wctm-count]').textContent=labels.matches+' '+available.length;
        results.replaceChildren();
        for(const m of available){
          const a=document.createElement('a');a.className='rok-wctm-result';a.href=linkFor(m);
          if(m.id===current.id)a.setAttribute('aria-current','true');
          const name=document.createElement('strong');name.textContent=m.mpn;
          const bins=document.createElement('span');bins.textContent=labels[m.bins];
          const features=document.createElement('span');features.textContent=labels[m.motion]+' · '+labels[m.wood];
          const width=document.createElement('span');width.textContent=m.opening==='adjustable'?labels.range+': '+m.range+'″':labels.exact+': '+m.opening+'″';
          const price=document.createElement('strong');price.textContent=m.price;
          const action=document.createElement('span');action.className='rok-wctm-action';action.textContent=m.id===current.id?labels.selected:labels.view+' →';
          a.append(name,bins,features,width,price,action);results.append(a);
        }
        const included=available.some(m=>m.id===current.id);
        panel.querySelector('[data-wctm-pending]').hidden=included;
        main.querySelectorAll('[name="add"],button[type="submit"]').forEach(button=>button.disabled=!included);
      };
      fields.forEach((key,index)=>controls[key].addEventListener('change',()=>{
        state[key]=controls[key].value;
        fields.slice(index+1).forEach(k=>state[k]='');
        render();
      }));
      panel.querySelector('[data-wctm-reset]').addEventListener('click',()=>{fields.forEach(k=>state[k]='');render();});
      const direct=panel.querySelector('[data-wctm-direct]');
      direct.replaceChildren(...models.map(m=>new Option(m.mpn,m.id)));direct.value=current.id;
      direct.addEventListener('change',()=>{
        const model=models.find(m=>m.id===direct.value);
        const url=new URL(model.url,location.origin);
        location.assign(url.toString());
      });
      panel.querySelector('[data-wctm-summary]').textContent=labels[current.bins]+' · '+labels[current.wood]+' · '+labels[current.motion]+(current.rear?' · '+labels.rear:'');
      panel.querySelector('[data-wctm-install]').textContent=(current.quad?labels.no_door:labels.door)+' · '+(current.full?labels.full:labels.short);
      const detail=this.variants[current.id];
      const type=state.type || current.types[0];
      detail.cabinet_recommendation=(current.types.length===2?labels.adjust_frame:labels[current.types[0]])+' · '+(current.opening==='adjustable'?labels.range+': '+current.range+'″':labels.exact+': '+current.opening+'″')+(current.stile!=='none'&&current.stile!=='adjustable'?' · '+labels.frame+': '+current.stile:'');
      const spec=detail.specifications?.find(s=>s.label==='Required opening — '+(type==='frameless'?'frameless':'face-frame'));
      detail.clear_opening=spec?.value || labels.exact+': '+(current.range||current.opening)+'″. '+labels.check;
      if(this.selector)this.selector.hidden=true;
      picker.before(panel);picker.hidden=true;picker.style.display='none';panel.hidden=false;
      render();
    }
    initializeLazyFamilySelector() {
      const panel = this.querySelector('[data-lazy-family-selector]');
      if (!panel) return false;
      const main = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"]');
      const picker = main?.querySelector('variant-options');
      const models = JSON.parse(panel.querySelector('[data-lazy-models]').textContent);
      const current = models.find(model => model.id === this.dataset.initialVariant);
      if (!picker || !current) return false;
      const controls = [...panel.querySelectorAll('[data-lazy-axis]')];
      const update = () => {
        let available = models;
        for (const control of controls) {
          const key = control.dataset.lazyAxis;
          const desired = control.value || current[key];
          const values = [...new Set(available.map(model => model[key]))];
          if (key === 'diameter') values.sort((a,b) => parseFloat(a) - parseFloat(b));
          control.replaceChildren(...values.map(value => new Option(value,value)));
          control.value = values.includes(desired) ? desired : values[0];
          available = available.filter(model => model[key] === control.value);
        }
        const selected = available[0];
        panel.querySelector('[data-lazy-mpn]').textContent = selected.mpn;
        return selected;
      };
      controls.forEach(control => control.addEventListener('change', () => {
        const selected = update();
        if (selected.id === this.dataset.initialVariant) return;
        const url = new URL(location.href);
        url.searchParams.set('variant',selected.id);
        url.searchParams.delete('cabinet_type');
        url.searchParams.delete('selection');
        controls.forEach(item => item.disabled = true);
        main.querySelectorAll('[name="add"]').forEach(button => button.disabled = true);
        location.assign(url.toString());
      }));
      update();
      this.querySelectorAll('[data-catalog-fit],[data-catalog-comparison]').forEach(item => item.hidden = true);
      if (this.selector) this.selector.hidden = true;
      picker.before(panel);
      picker.hidden = true;
      picker.style.display = 'none';
      panel.hidden = false;
      return true;
    }
    initializeReviewedSelector() {
      const panel = this.querySelector('[data-reviewed-selector]');
      if (!panel) return false;
      const main = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"]');
      const picker = main?.querySelector('variant-options');
      if (!picker) return false;
      const models = JSON.parse(panel.querySelector('[data-reviewed-models]').textContent);
      const current = models.find(model => model.id === this.dataset.initialVariant);
      if (!current) return false;
      const size = panel.querySelector('[data-reviewed-width]');
      const choice = panel.querySelector('[data-reviewed-choice]');
      const height = panel.querySelector('[data-reviewed-height]');
      const update = preferred => {
        let available = size ? models.filter(model => model.width === size.value) : models;
        if (height) {
          const heights = [...new Set(available.map(model => model.height))];
          const desired = height.value || current.height;
          height.replaceChildren(...heights.map(value => new Option(value,value)));
          height.value = heights.includes(desired) ? desired : heights[0];
          available = available.filter(model => model.height === height.value);
        }
        choice.replaceChildren(...available.map(model => new Option(model.label, model.id)));
        choice.value = available.some(model => model.id === preferred) ? preferred : available.find(model => model.label === current.label)?.id || available[0].id;
        const selected = available.find(model => model.id === choice.value);
        panel.querySelector('[data-reviewed-mpn]').textContent = selected.mpn;
        panel.querySelector('[data-reviewed-summary]').textContent = selected.summary;
      };
      const navigate = () => {
        const selected = models.find(model => model.id === choice.value);
        if (!selected || selected.id === this.dataset.initialVariant) return;
        const url = new URL(location.href);
        url.searchParams.set('variant', selected.id);
        url.searchParams.delete('cabinet_type');
        url.searchParams.delete('selection');
        panel.querySelectorAll('select').forEach(control => control.disabled = true);
        main.querySelectorAll('[name="add"]').forEach(button => button.disabled = true);
        location.assign(url.toString());
      };
      if (size) {
        const widths = [...new Set(models.map(model => model.width))].sort((a,b) => Number(a) - Number(b));
        size.replaceChildren(...widths.map(width => new Option(panel.hasAttribute('data-reviewed-text-width') ? width : width + '″', width)));
        size.value = current.width;
        size.addEventListener('change', () => { update(choice.value); navigate(); });
      }
      if (height) height.addEventListener('change', () => { update(choice.value); navigate(); });
      choice.addEventListener('change', () => { update(choice.value); navigate(); });
      update(current.id);
      const legacyFit = this.querySelector('[data-catalog-fit]');
      if (legacyFit) legacyFit.hidden = true;
      const comparison = this.querySelector('[data-catalog-comparison]');
      if (comparison) comparison.hidden = true;
      if (this.selector) this.selector.hidden = true;
      picker.before(panel);
      picker.hidden = true;
      picker.style.display = 'none';
      panel.hidden = false;
      return true;
    }
    initializeCatalogFit() {
      if (this.dataset.productHandle === "rev-a-shelf-cjd-jewelry-watch-organizers" && this.dataset.initialVariant === "67597984629043") return;
      if (this.initializeLazyFamilySelector()) return;
      if (this.initializeReviewedSelector()) return;
      if (this.querySelector('[data-waste-choices]')) return;
      const panel = this.querySelector('[data-catalog-fit]');
      const main = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"]');
      const picker = main?.querySelector('variant-options');
      if (!panel || !picker || this.fitUI) return;
      const labels = JSON.parse(panel.querySelector('[data-catalog-labels]').textContent);
      const opening = (detail, type) => detail.specifications?.find(s => s.label === 'Required opening — ' + (type === 'framed' ? 'face-frame' : 'frameless'))?.value || '';
      const width = value => value.match(/^(\d+(?:\.\d+)?)\s*["″]\s*W/i)?.[1] || '';
      const finish5322 = this.dataset.productHandle === 'rev-a-shelf-5322-base-cabinet-pullout-organizers-soft-close' || this.dataset.productHandle.startsWith('rev-a-shelf-5322ut-');
      if (panel.dataset.familyTitle) main.querySelectorAll('h1').forEach(heading=>heading.textContent=panel.dataset.familyTitle);
      const foil = finish5322 || this.dataset.productHandle === 'rev-a-shelf-447-foil-wrap-organizers-soft-close';
      const foilFits = {'447-BCBBSC-5C':{type:'framed',cabinet:'9'},'447-BCSC-5C':{type:'framed',cabinet:'9'},'447-BCBBSC-8C':{type:'framed',cabinet:'12'},'447-BCSC-8C':{type:'framed',cabinet:'12'},'447-BCSC-6C':{type:'frameless',cabinet:'9'},'447-BCSC-9C':{type:'frameless',cabinet:'12'}};
      const models = JSON.parse(panel.querySelector('[data-catalog-models]').textContent).map(model => {
        const detail = this.variants[model.id];
        const finishMatch = finish5322 && model.mpn?.match(/^5322(?:UT)?-BCSC-(5|6|8|9|11)-(GR|MP|FOG)$/);
        if (finishMatch) foilFits[model.mpn] = {type:['6','9'].includes(finishMatch[1]) ? 'frameless' : 'framed',cabinet:({'5':'9','6':'9','8':'12','9':'12','11':'15'})[finishMatch[1]]};
        return {...model, finish:finishMatch ? finishMatch[2] : '', framed:opening(detail,'framed'), frameless:opening(detail,'frameless'), foilFit:foil ? foilFits[model.mpn] : null};
      });
      if (!models.every(m => width(m.framed) || width(m.frameless))) return;
      const current = models.find(m => m.id === this.dataset.initialVariant);
      if (!current) return;
      const type = panel.querySelector('[data-catalog-type]');
      if (foil) models.forEach(model => {
        const fit = model.foilFit;
        if (fit) this.variants[model.id].cabinet_recommendation = fit.cabinet+'″ · '+[...type.options].find(option=>option.value === fit.type).textContent;
      });
      const sameOpening = models.every(m=>this.variants[m.id]?.shared_opening) || (this.dataset.productHandle.startsWith('rev-a-shelf-5psp-blind-corner-organizers') || ['rev-a-shelf-5707-blind-corner-organizers-soft-close','rev-a-shelf-599-blind-corner-organizers','rev-a-shelf-4sbsu-under-sink-organizers','rev-a-shelf-4wfr-foil-wrap-organizers','rev-a-shelf-4dmcb-cutting-board-prep-drawers','rev-a-shelf-4fsco-food-storage-container-organizers','rev-a-shelf-4sr-spice-organizers'].includes(this.dataset.productHandle)) && models.every(m => m.framed && m.framed === m.frameless);
      const cookware = this.dataset.productHandle === 'rev-a-shelf-5cw2-pots-pans-lid-organizers-soft-close';
      panel.querySelector('[data-catalog-type-field]').hidden = sameOpening || cookware;
      const sizes = panel.querySelector('[data-catalog-width]');
      const choices = panel.querySelector('[data-catalog-model]');
      const guided = panel.querySelector('[data-catalog-guided]');
      const finishes = panel.querySelector('[data-5322-finish]');
      let direct = new URL(location.href).searchParams.get('selection') === 'direct';
      const requestedType = new URL(location.href).searchParams.get('cabinet_type');
      type.value = ['framed','frameless'].includes(requestedType) && (!foil || current.foilFit?.type === requestedType) && width(current[requestedType]) ? requestedType : foil ? current.foilFit.type : width(current.framed) ? 'framed' : 'frameless';
      if (cookware) type.value = 'frameless';
      for (const option of [...type.options]) option.disabled = !models.some(m=>width(m[option.value]));
      const navigate = id => {
        const model = models.find(m=>m.id === id);
        if (!model || id === this.dataset.initialVariant) return;
        main.querySelectorAll('[name="add"],button[type="submit"]').forEach(button=>button.disabled=true);
        panel.querySelectorAll('button,select').forEach(control=>control.disabled=true);
        const url = new URL(location.href);
        url.pathname = new URL(model.url,location.origin).pathname;
        url.searchParams.set('variant',id);
        url.searchParams.set('cabinet_type',type.value);
        url.searchParams.set('selection',direct ? 'direct' : 'guided');
        location.assign(url.toString());
      };
      const render = (preferred=current.id, preferredWidth, preferredFinish) => {
        const matching = models.filter(m=>width(m[type.value]) && (!foil || m.foilFit?.type === type.value));
        const choiceWidth = m => foil ? m?.foilFit?.cabinet || '' : width(m?.[type.value] || '');
        const selected = models.find(m=>m.id === preferred);
        const widths = [...new Set(matching.map(m=>choiceWidth(m)))].sort((a,b)=>Number(a)-Number(b));
        sizes.replaceChildren(...widths.map(w=>new Option(w+'″',w)));
        sizes.value = widths.includes(preferredWidth) ? preferredWidth : widths.includes(choiceWidth(selected)) ? choiceWidth(selected) : widths[0];
        let available = direct ? models : matching.filter(m=>choiceWidth(m) === sizes.value);
        if (finish5322) {
          panel.querySelector('[data-5322-finish-field]').hidden = direct;
          panel.querySelector('[data-catalog-model-field]').hidden = !direct;
          const options = ['GR','MP','FOG'].filter(f=>available.some(m=>m.finish === f));
          const wanted = preferredFinish || selected?.finish;
          finishes.replaceChildren(...options.map(f=>new Option(labels[f],f)));
          finishes.value = options.includes(wanted) ? wanted : options[0];
          if (!direct) available = available.filter(m=>m.finish === finishes.value);
        }
        choices.replaceChildren(...available.map(m=>new Option(this.variants[m.id]?.door_orientation ? this.variants[m.id].door_orientation+' — '+m.mpn+' — '+m.price : this.dataset.productHandle === 'rev-a-shelf-5pd-wall-cabinet-pull-down-shelves' ? (m.mpn.endsWith('FOG') ? labels.FOG : labels.chrome) : (foil || this.dataset.productHandle === 'rev-a-shelf-449-base-cabinet-pullout-organizers-soft-close') ? m.mpn : m.mpn+(m.title && !m.title.includes(m.mpn) ? ' — '+m.title : '')+' — '+m.price,m.id)));
        choices.value = available.some(m=>m.id === preferred) ? preferred : available[0].id;
        const chosen = models.find(m=>m.id === choices.value);
        guided.hidden = direct;
        panel.querySelectorAll('[data-catalog-mode]').forEach(button=>button.setAttribute('aria-pressed',String((button.dataset.catalogMode === 'direct') === direct)));
      };
      if (finishes) finishes.addEventListener('change',()=>{render(choices.value,sizes.value,finishes.value);navigate(choices.value);});
      type.addEventListener('change',()=>{render(choices.value);navigate(choices.value);});
      sizes.addEventListener('change',()=>{render(choices.value,sizes.value);navigate(choices.value);});
      choices.addEventListener('change',()=>navigate(choices.value));
      panel.querySelectorAll('[data-catalog-mode]').forEach(button=>button.addEventListener('click',()=>{direct=button.dataset.catalogMode === 'direct';render(current.id);}));
      this.querySelectorAll('[data-catalog-link]').forEach(link=>link.addEventListener('click',event=>{
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();direct=true;navigate(link.dataset.catalogLink);
        if (link.dataset.catalogLink === current.id) {render(current.id);panel.scrollIntoView({behavior:'smooth',block:'center'});choices.focus({preventScroll:true});}
      }));
      render();
      if (this.selector) this.selector.hidden=true;
      picker.before(panel);picker.hidden=true;picker.style.display='none';panel.hidden=false;
    }
    initializeProduceSelector() {
      const main = document.querySelector('section[data-product-handle="' + this.dataset.productHandle + '"]');
      const picker = main?.querySelector('variant-options');
      if (!picker) return;
      const models = Object.entries(this.variants).map(([id, detail]) => {
        const match = detail.mpn?.match(/^4SSB-(15|18)-(WNMB|MP)$/);
        return match ? {id, width:match[1], finish:match[2]} : null;
      }).filter(Boolean);
      if (!models.some(m => m.id === this.dataset.initialVariant)) return;
      const panel = document.createElement('div');
      panel.className = 'rok-produce-selector';
      panel.innerHTML = '<label for="rok-produce-model">Size &amp; finish</label><select id="rok-produce-model"></select>';
      const select = panel.querySelector('select');
      for (const m of models) select.add(new Option(m.width + '″ cabinet · ' + (m.finish === 'MP' ? 'Maple / Stainless steel' : 'Walnut / Black'),m.id));
      select.value = this.dataset.initialVariant;
      select.addEventListener('change', () => {
        if (select.value === this.dataset.initialVariant) return;
        main.querySelectorAll('[name="add"],button[type="submit"]').forEach(b=>b.disabled=true);
        select.disabled=true;
        const url = new URL(location.href);
        url.searchParams.set('variant',select.value);
        location.assign(url.toString());
      });
      picker.before(panel);picker.hidden=true;picker.style.display='none';
    }
    initializeFitSelector(selector, picker) {
      const ui = selector.querySelector('[data-rok-fit-selector]');
      this.fitLabels = JSON.parse(ui.querySelector('[data-fit-labels]').textContent);
      const products = JSON.parse(ui.querySelector('[data-fit-products]').textContent);
      this.fitModels = products.map(model => {
        const match = model.sku.match(/^(?:RV)?448(?:UT|KB|SW|PTH)?-(BCBBSC|BCSCSD|BCSC|BDDSC)-(5|6|8|9|11|14)C$/);
        if (!match) return null;
        const [, family, size] = match;
        const special = size === '6' || size === '9';
        const details = this.variants[model.id];
        const width = ({5:9,6:9,8:12,9:12,11:15,14:18})[size];
        return {...model, openingWidths:model.sku.includes('448PTH-') ? (size === '6' ? {face_frame:'6.625',frameless:'7.125'} : {face_frame:'8.5',frameless:'9'}) : null, width:String(width), installation:family === 'BDDSC' ? 'under' : 'full', slide:({BCBBSC:'ball',BCSCSD:'servo',BCSC:'blum',BDDSC:'soft'})[family], types:(model.sku.includes('448SW-') || model.sku.includes('448PTH-')) ? ['face_frame','frameless'] : special ? ['frameless'] : family === 'BCSC' && (size === '5' || size === '8') ? ['face_frame'] : ['face_frame','frameless'], organizerWidth:details?.specifications?.find(spec=>spec.label === 'Product width')?.value || ''};
      }).filter(Boolean);
      if (this.fitModels.length !== products.length) return;
      this.fitPicker = picker;
      this.fitUI = ui;
      const selected = this.fitModels.find(model=>model.id === this.dataset.initialVariant);
      if (!selected) return;
      const requestedType = new URL(location.href).searchParams.get('cabinet_type');
      this.fitType = selected.types.includes(requestedType) ? requestedType : selected.types[0];
      this.fitCurrent = selected;
      this.fitWidth = ui.querySelector('[data-fit-width]');
      this.fitInstall = ui.querySelector('[data-fit-install]');
      this.fitSlide = ui.querySelector('[data-fit-slide]');
      this.fitModelSelect = ui.querySelector('[data-fit-model-select]');
      ui.querySelectorAll('[data-cabinet-type]').forEach(button=>button.addEventListener('click',()=>{
        this.fitType = button.dataset.cabinetType;
        this.updateFitOptions(this.fitCurrent?.openingWidths ? this.fitCurrent : undefined);
        this.applyFitSelection();
      }));
      this.fitWidth.addEventListener('change',()=>{this.updateFitOptions();this.applyFitSelection();});
      this.fitInstall.addEventListener('change',()=>{this.updateFitOptions();this.applyFitSelection();});
      this.fitSlide.addEventListener('change',()=>{this.updateFitOptions();this.applyFitSelection();});
      this.fitModelSelect.addEventListener('change',()=>this.applyFitSelection());
      this.fitMode = new URL(location.href).searchParams.get('selection') === 'direct' ? 'direct' : 'guided';
      this.fitDirect = ui.querySelector('[data-fit-direct-select]');
      ui.querySelectorAll('[data-fit-mode]').forEach(button=>button.addEventListener('click',()=>this.setFitMode(button.dataset.fitMode)));
      this.fitDirect.addEventListener('change',()=>this.selectFitModel(this.fitDirect.value));
      this.querySelectorAll('[data-compare-variant]').forEach(link=>link.addEventListener('click',event=>{
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.setFitMode('direct');
        this.selectFitModel(link.dataset.compareVariant);
        this.selector.scrollIntoView({block:'start',behavior:'smooth'});
        this.fitDirect.focus({preventScroll:true});
      }));
      this.updateFitOptions(selected);
      selector.querySelector('[data-rok-legacy-selector]').hidden = true;
      ui.hidden = false;
      this.setFitMode(this.fitMode);
    }
    setFitMode(mode) {
      this.fitMode = mode;
      this.fitUI.querySelector('[data-fit-guided]').hidden = mode === 'direct';
      this.fitUI.querySelector('[data-fit-direct]').hidden = mode !== 'direct';
      this.fitUI.querySelectorAll('[data-fit-mode]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.fitMode === mode)));
      this.renderFitSummary(this.fitCurrent);
    }
    selectFitModel(id) {
      const model = this.fitModels.find(item=>item.id === id);
      if (!model) return;
      if (!model.types.includes(this.fitType)) this.fitType = model.types[0];
      this.updateFitOptions(model);
      this.applyFitSelection();
    }
    setFitOptions(select, items, wanted) {
      select.replaceChildren(...items.map(item=>new Option(item.label,item.value)));
      select.value = items.some(item=>item.value === wanted) ? wanted : items[0].value;
    }
    updateFitOptions(preferred) {
      const models = this.fitModels.filter(model=>model.types.includes(this.fitType)).map(model=>({...model,width:model.openingWidths?.[this.fitType] || model.width}));
      const width = models.find(model=>model.id === preferred?.id)?.width || this.fitWidth.value;
      const install = preferred?.installation || this.fitInstall.value;
      const current = preferred?.id || this.fitModelSelect.value;
      const slide = preferred?.slide || this.fitSlide.value;
      const widths = [...new Set(models.map(model=>model.width))].sort((a,b)=>Number(a)-Number(b));
      this.setFitOptions(this.fitWidth,widths.map(value=>({value,label:({'6.625':'6⅝','7.125':'7⅛','8.5':'8½'}[value] || value)+'″'})),width);
      const forWidth = models.filter(model=>model.width === this.fitWidth.value);
      const installations = ['full','under'].filter(value=>forWidth.some(model=>model.installation === value));
      this.setFitOptions(this.fitInstall,installations.map(value=>({value,label:this.fitLabels[value]})),install);
      const choices = forWidth.filter(model=>model.installation === this.fitInstall.value);
      this.setFitOptions(this.fitSlide,[...new Set(choices.map(model=>model.slide))].map(value=>({value,label:this.fitLabels[value]})),slide);
      const matching = choices.filter(model=>model.slide === this.fitSlide.value);
      this.setFitOptions(this.fitModelSelect,matching.map(model=>({value:model.id,label:this.variants[model.id].mpn})),current);
      this.fitUI.querySelector('[data-fit-model-choice]').hidden = matching.length < 2;
      this.fitUI.querySelectorAll('[data-cabinet-type]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.cabinetType === this.fitType)));
    }
    applyFitSelection() {
      const model = this.fitModels.find(item=>item.id === this.fitModelSelect.value);
      if (!model) return;
      if ((model.sku.includes('448UT-') || model.sku.includes('448KB-') || model.sku.includes('448SW-') || model.sku.includes('448PTH-')) && model.id !== this.dataset.initialVariant) {
        const target = new URL(model.url, location.origin);
        const url = new URL(location.href);
        url.pathname = target.pathname;
        url.searchParams.set('variant', model.id);
        url.searchParams.set('cabinet_type', this.fitType);
        url.searchParams.set('selection', this.fitMode);
        location.assign(url.toString());
        return;
      }
      const input = Array.from(this.fitPicker.querySelectorAll('input[type=radio]')).find(input=>input.value === model.title);
      if (!input) return;
      this.fitCurrent = model;
      input.checked = true;
      input.dispatchEvent(new Event('change',{bubbles:true}));
      this.renderFitSummary(model);
      const url = new URL(location.href);
      url.searchParams.set('cabinet_type',this.fitType);
      history.replaceState(history.state,'',url);
    }
    renderFitSummary(model) {
      const details = this.variants[model.id];
      this.fitCurrent = model;
      this.fitUI.querySelector('[data-fit-model]').textContent = details.mpn;
      const binCount = this.fitUI.querySelector('[data-ut-bin-count] strong');
      if (binCount) binCount.textContent = model.sku.endsWith('-11C') ? this.fitLabels.bins_six : this.fitLabels.bins_three;
      const slideHelp = this.fitUI.querySelector('[data-fit-help]');
      slideHelp.textContent = this.fitLabels[model.slide+'_help'];
      slideHelp.hidden = false;
      this.fitDirect.value = model.id;
      this.querySelectorAll('[data-compare-row]').forEach(row=>row.dataset.selected = String(row.dataset.compareRow === model.id));
      this.selector.querySelector('[data-fit-accessory-note]').hidden = !['RV448-BCSC-8C','RV448UT-BCSC-8C','RV448KB-BCSC-8C'].includes(model.sku);
      const dimensions = ['Product width','Product depth','Product height'].map((label,index)=>(details.specifications.find(spec=>spec.label === label)?.value || '—')+' '+['W','D','H'][index]);
      this.selector.querySelector('[data-fit-dimensions]').textContent = dimensions.join(' × ');
      const main = this.fitPicker.closest('section[data-product-handle]');
      const openingLabel = this.fitType === 'frameless' ? 'Required opening — frameless' : 'Required opening — face-frame';
      const opening = details.specifications.find(spec=>spec.label === openingLabel)?.value;
      const openingField = main.querySelector('[data-rok-field="clear_opening"]');
      if (openingField && opening) openingField.textContent = this.fitMode === 'direct' ? details.clear_opening : this.fitLabels[this.fitType]+': '+opening;
      const recommendation = main.querySelector('[data-rok-field="cabinet_recommendation"]');
      if (recommendation) recommendation.textContent = this.fitMode === 'direct' || model.openingWidths ? this.fitLabels[model.installation]+' · '+this.fitLabels.direct_fit : model.width+'″ '+this.fitLabels[this.fitType].toLowerCase()+' · '+this.fitLabels[model.installation];
      if (model.installation === 'under') {
        this.querySelectorAll('[data-rok-field="description"]').forEach(el=>{el.textContent=el.textContent.replace('All units require a full-height cabinet (where no drawer is above) and cabinet door must attach to gain the full features of the unit.','This shorter organizer is designed for installation below a drawer. The cabinet door must attach to the organizer.');});
      }
    }
    disconnectedCallback() {
      document.removeEventListener('variantChangeEnd', this.onVariantChange);
    }
    renderVariant(id) {
      const details = this.variants[String(id)];
      const formatCorner = !!details?.door_orientation;
      if (details?.door_orientation && !details.cabinet_recommendation?.includes(details.door_orientation)) {
        details.cabinet_recommendation = [details.cabinet_recommendation, details.door_orientation+'. Viewed from in front of the cabinet.'].filter(Boolean).join(' · ');
      }
      const sharedCornerOpening = details?.shared_opening === true;
      if (sharedCornerOpening && details) {
        const opening = details.specifications?.find(spec=>spec.label === 'Required opening — face-frame');
        if (opening) { details.fit_label = 'Opening:'; }
      }
      if (['4WLS882','6012','6013','6065','6071','6072','6073','6271','6272','LD-2472','LD-2062','LD-4BW','LD-4NW'].includes(details?.series)) {
        const clean = value => typeof value === 'string' ? value.replaceAll('Kidney-Shaped-Shaped','Kidney-Shaped').replaceAll('Ã—','×').replaceAll('â€”','—').replaceAll('â€¢','•').replaceAll('Â®','®').replaceAll('22.75"','22-3/4″').replaceAll('16.25"','16-1/4″').replaceAll('13.25"','13-1/4″').replaceAll('19.25"','19-1/4″') : value;
        for (const key of Object.keys(details)) if (typeof details[key] === 'string') details[key] = clean(details[key]);
        details.specifications = (details.specifications || []).filter(spec => !(details.mpn === '4WLS882-38-570' && spec.label === 'Diameter')).map(spec => ({...spec,label:clean(spec.label),value:clean(spec.value)}));
        details.downloads = (details.downloads || []).map(doc => ({...doc,label:clean(doc.label)}));
      }

      const pantryOpenings = {
        '448-TP43-11-1': { cabinet:'15', framed:'11-1/2″ W × 23″ D × 43-1/2″ H', frameless:'11-1/8″ W × 22-1/4″ D × 43-3/8″ H' },
        '448-TP51-11-1': { cabinet:'15', framed:'11-1/2″ W × 23″ D × 51″ H', frameless:'11-1/8″ W × 22-1/4″ D × 50-7/8″ H' },
        '448-TP58-14-1': { cabinet:'18', framed:'14-1/2″ W × 23″ D × 58-1/2″ H', frameless:'14-1/8″ W × 22-1/4″ D × 58-3/8″ H' },
        '448-TP58-5-1': { cabinet:'9', framed:'5-1/2″ W × 23″ D × 58-1/2″ H', frameless:'5-1/8″ W × 22-1/4″ D × 58-1/2″ H' }
      };
      const pantryFit = this.dataset.productHandle === 'rev-a-shelf-448-tall-pantry-pullouts-soft-close' && pantryOpenings[details?.mpn];
      if (pantryFit) {
        details.clear_opening = 'Face-frame: '+pantryFit.framed+'; Frameless: '+pantryFit.frameless;
        details.cabinet_recommendation = pantryFit.cabinet+'″ wide pantry cabinet. Confirm the minimum clear opening below.';
        const rows = [
          {label:'Required opening — face-frame',value:pantryFit.framed},
          {label:'Required opening — frameless',value:pantryFit.frameless}
        ];
        details.specifications = [...(details.specifications || []).filter(spec=>!rows.some(row=>row.label === spec.label)),...rows];
      }
      if(details?.mpn==='544-12KD-1') {
        details.cabinet_recommendation='15-inch base cabinet or 30-inch sink base cabinet, provided the required clear opening and usable space are available.';
        if(!details.description.includes('Cabinet fit: suitable')) details.description=details.description.replace(/Designed for 30[^.]*\./g,'')+' Cabinet fit: suitable for a 15-inch base cabinet or a 30-inch sink base cabinet when the clear opening, depth and height below are met. Check hinges and plumbing for interference.';
      }
      const correction = this.fitCorrections?.[details?.mpn];
      if (correction && details && !details.fit_correction_applied && /not listed|confirm|verify|see model/i.test(details.clear_opening || '')) {
        details.clear_opening = correction.text;
        details.fit_label = correction.label;
        details.fit_correction_applied = true;
        if (correction.specs) details.specifications = [...(details.specifications || []).filter(spec=>!correction.specs.some(row=>row.label === spec.label)),...correction.specs];
      }
      if (details?.mpn === '4MR-18-1' || details?.mpn === '4MR-18W-1') {
        details.clear_opening = 'Face-frame and frameless: 14-1/2″ W × 3-3/4″ D × 15-1/4″ H. Mounts on a cabinet door or flat wall. Keep shelves, hinges and stored items clear of the organizer when closing the door.';
        details.fit_label = 'Required clear opening:';
        details.cabinet_recommendation = 'Cabinet door or flat mounting surface at least 14-1/2″ wide.';
      }
      if (details?.mpn === '4VR-24-1') {
        details.cabinet_recommendation = '24″ wide vanity cabinet with at least a 21″ clear opening.';
        details.clear_opening = 'Minimum opening width: 21″. Rack dimensions: 20-1/4″ W × 3-1/8″ D × 15-1/2″ H. Mounts inside the cabinet door; allow clearance for shelves, hinges, plumbing and the door swing.';
        details.fit_label = 'Door mounting space:';
      }
      if (details?.mpn === '4WUTKB-36-1' || details?.mpn === '4WUTKB-36SH-1') {
        const insertHeight = details.mpn === '4WUTKB-36SH-1' ? '2-3/8″' : '2-7/8″';
        details.clear_opening = 'Measure the inside of your drawer. Untrimmed insert: 33-1/8″ W × 22″ D × '+insertHeight+' H. Trim-to-fit down to 25-1/4″ W × 16-3/8″ D; do not trim smaller. Allow enough usable drawer height for the insert and knife handles so the drawer closes freely. Drop-in installation; cabinet frame type does not change these drawer measurements.';
        details.fit_label = 'Drawer fit and trim limits:';
        details.cabinet_recommendation = 'Fits inside a drawer; use interior drawer measurements rather than outside cabinet width.';
      }
      const main = document.querySelector(`section[data-product-handle="${CSS.escape(this.dataset.productHandle)}"]`);
      const roots = [this, main].filter(Boolean);
      const fitLabel = main?.querySelector('[data-rok-field="clear_opening"]')?.closest('p')?.querySelector('b');
      if (fitLabel) fitLabel.textContent = details?.fit_label || 'Required clear opening:';
      const cabinetRow = main?.querySelector('[data-rok-cabinet-row]');
      if (cabinetRow) cabinetRow.hidden = !details?.cabinet_recommendation;
      const status = main?.querySelector('[data-rok-stock]');
      if (status) {
        // ROK can source from multiple vendors. Only Sean may authorize an override.
        const override = details?.storefront_availability_override;
        const selectedId = String(id);
        const availability = this.salesStatus[selectedId] || (['Out of Stock','Discontinued'].includes(override) ? override : 'In Stock');
        status.dataset.rokStock = availability;
        const label = status.querySelector('[data-rok-stock-label]');
        if (label) label.textContent = availability;
        status.hidden = !availability;
        if (status.hidden) status.style.display = 'none';
        else status.style.removeProperty('display');
      }
      for (const root of roots) {
        root.querySelectorAll('[data-rok-variant-content],[data-rok-model-row]').forEach(el => { el.hidden = !details; });
        root.querySelectorAll('[data-rok-unavailable]').forEach(el => { el.hidden = !!details; });
        root.querySelectorAll('[data-rok-field]').forEach(el => { let value = details?.[el.dataset.rokField] || ''; if (value.includes('not listed in the source catalog')) value = 'Confirm the required cabinet opening before ordering.'; if (['description','included'].includes(el.dataset.rokField)) value = value.replace(/ • /g, '\n• '); el.textContent = value.replace(/framelss/gi,'Frameless').replace(/measurments/gi,'Measurements'); });
      }

      if (window.location.pathname.endsWith('/rev-a-shelf-448-tall-pantry-pullouts-soft-close')) {
      for (const field of ['description','included']) {
        const original = this.querySelector('[data-rok-field="'+field+'"]');
        if (!original) continue;
        const block = document.createElement('div');
        block.dataset.rokField = field;
        block.style.cssText = 'line-height:1.65;white-space:normal;margin:16px 0';
        const value = original.textContent.replace(/durabiltiy/gi,'durability').trim();
        const parts = field === 'description' ? value.split(/\s*•\s*/) : value.split(/\s+-\s+|\s*•\s*/);
        if (field === 'description') {
          let intro = parts.shift().trim();
          const second = intro.indexOf(intro.slice(0,50),50);
          if (second > 0 && intro.slice(0,second).trim() === intro.slice(second).trim()) intro = intro.slice(0,second).trim();
          const paragraph = document.createElement('p');
          paragraph.textContent = intro;
          paragraph.style.margin = '0 0 16px';
          block.append(paragraph);
        }
        if (parts.length) {
          const list = document.createElement('ul');
          list.style.cssText = 'list-style:disc;padding-left:24px;margin:0;display:block';
          [...new Set(parts.map(text=>text.trim()).filter(Boolean))].forEach(text=>{
            const item = document.createElement('li');
            item.style.cssText = 'display:list-item;margin:0 0 10px;padding-left:4px';
            item.textContent = text;
            list.append(item);
          });
          block.append(list);
        }
        original.replaceWith(block);
      }
      const pantryTitle = this.querySelector('[data-rok-field="model_title"]');
      if (pantryTitle && !/^Rev-A-Shelf/i.test(pantryTitle.textContent)) pantryTitle.textContent = 'Rev-A-Shelf '+pantryTitle.textContent;
      }

      const sku = main?.querySelector('[id^="Sku-"]');
      if (sku) sku.hidden = !details;
      const price = main?.querySelector('[id^="price-"]');
      if (price) price.hidden = !details;
      const specs = this.querySelector('[data-rok-specifications]');
      specs.replaceChildren();
      for (const item of details?.specifications || []) {
        if (sharedCornerOpening && (item.label === 'Required opening — frameless' || item.label === 'Required opening — inset frameless')) continue;
        const row = document.createElement('tr');
        const th = document.createElement('th'); th.scope = 'row'; th.textContent = sharedCornerOpening && item.label === 'Required opening — face-frame' ? 'Opening' : sharedCornerOpening && item.label === 'Required opening — inset face-frame' ? 'Opening — inset door' : item.label;
        const td = document.createElement('td'); td.textContent = item.value;
        row.append(th, td); specs.append(row);
      }
      this.querySelector('#organizer-included').hidden = !details?.included;
      this.querySelector('#organizer-downloads').hidden = !details?.downloads?.length;
      this.querySelector('[data-rok-download-nav]').hidden = !details?.downloads?.length;
      const downloads = this.querySelector('[data-rok-downloads]');
      downloads.replaceChildren();
      for (const item of details?.downloads || []) {
        const url = new URL(item.url);
        if (url.protocol !== 'https:') continue;
        const link = document.createElement('a');
        link.href = url.href;
        link.textContent = `${item.label} ↗`;
        link.target = '_blank';
        link.rel = 'noopener';
        downloads.append(link);
      }
      if (this.fitUI) {
        const model = this.fitModels.find(item=>item.id === String(id));
        if (model) {this.updateFitOptions(model);this.renderFitSummary(model);}
      }
      if (formatCorner) {
        for (const root of roots) {
          const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
          let node;while((node=walker.nextNode())) {
            if(node.parentElement.closest('script,style,textarea'))continue;
            const formatted=rokCornerInches(node.nodeValue);
            if(formatted!==node.nodeValue)node.nodeValue=formatted;
          }
        }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-organizer-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rok-organizer-details')) {
  customElements.define('rok-organizer-details', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-rok-variants]').textContent);
      this.onVariantChange = event => {
        const main = event.target.closest('section[data-product-handle]');
        if (main?.dataset.productHandle !== this.dataset.productHandle) return;
        this.renderVariant(event.target.currentVariant?.id);
      };
      document.addEventListener('variantChangeEnd', this.onVariantChange);
      this.renderVariant(this.dataset.initialVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('variantChangeEnd', this.onVariantChange);
    }
    renderVariant(id) {
      const details = this.variants[String(id)];
      const main = document.querySelector(`section[data-product-handle="${CSS.escape(this.dataset.productHandle)}"]`);
      const roots = [this, main].filter(Boolean);
      const status = main?.querySelector('[data-rok-stock]');
      if (status) status.dataset.rokStock = details?.availability_status || '';
      for (const root of roots) {
        root.querySelectorAll('[data-rok-variant-content],[data-rok-model-row]').forEach(el => { el.hidden = !details; });
        root.querySelectorAll('[data-rok-unavailable]').forEach(el => { el.hidden = !!details; });
        root.querySelectorAll('[data-rok-field]').forEach(el => { el.textContent = details?.[el.dataset.rokField] || ''; });
      }
      const sku = main?.querySelector('[id^="Sku-"]');
      if (sku) sku.hidden = !details;
      const price = main?.querySelector('[id^="price-"]');
      if (price) price.hidden = !details;
      const downloads = this.querySelector('[data-rok-downloads]');
      downloads.replaceChildren();
      for (const item of details?.downloads || []) {
        const url = new URL(item.url);
        if (url.protocol !== 'https:') continue;
        const link = document.createElement('a');
        link.href = url.href;
        link.textContent = `${item.label} ↗`;
        link.target = '_blank';
        link.rel = 'noopener';
        downloads.append(link);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-portfolio"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rok-portfolio')){customElements.define('rok-portfolio',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const opts={signal:this.abort.signal};this.cards=[...this.querySelectorAll('[data-project]')];this.dialog=this.querySelector('.rkp__dialog');this.holder=this.querySelector('[data-dialog-content]');const toolbar=this.querySelector('[data-toolbar]');if(this.cards.length)toolbar.hidden=false;const filters=[...this.querySelectorAll('[data-filter]')];filters.forEach(button=>{if(button.dataset.filter!=='all'&&!this.cards.some(card=>card.dataset.room.split(' ').includes(button.dataset.filter)))button.hidden=true;button.addEventListener('click',()=>{filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;this.cards.forEach(card=>{card.hidden=button.dataset.filter!=='all'&&!card.dataset.room.split(' ').includes(button.dataset.filter);if(!card.hidden)count++;});this.setCount(count);this.querySelector('[data-no-results]').hidden=count>0;},opts);});this.setCount(this.cards.length);this.setupGallery(opts);
if(this.dialog&&typeof this.dialog.showModal==='function'){this.cards.forEach(card=>{const summary=card.querySelector('summary');summary.setAttribute('aria-haspopup','dialog');summary.addEventListener('click',event=>{event.preventDefault();this.openProject(card);},opts);});this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),opts);this.dialog.addEventListener('close',()=>this.restoreProject(),opts);this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},opts);document.addEventListener('shopify:block:select',event=>{if(this.contains(event.target)){const card=event.target.closest('[data-project]');if(card)this.openProject(card);}},opts);}
const openLinkedProject=()=>{const key=new URLSearchParams(location.search).get('project');const card=this.cards.find(c=>c.dataset.projectKey===key);if(card){if(this.dialog&&typeof this.dialog.showModal==='function')this.openProject(card);else{card.open=true;card.scrollIntoView();}}};openLinkedProject();}
setupGallery(opts){
 this.lightbox=this.querySelector('[data-lightbox]');
 if(!this.lightbox||typeof this.lightbox.showModal!=='function')return;
 this.querySelectorAll('[data-gallery-photo]').forEach(link=>link.setAttribute('aria-haspopup','dialog'));
 this.addEventListener('click',event=>{const link=event.target.closest('[data-gallery-photo]');if(!link||!this.contains(link))return;event.preventDefault();this.galleryLinks=[...link.closest('.rkp__gallery').querySelectorAll('[data-gallery-photo]')];this.galleryOrigin=link;this.galleryIndex=this.galleryLinks.indexOf(link);this.querySelector('[data-gallery-title]').textContent=link.closest('[data-detail]').querySelector('h2').textContent;this.showPhoto(this.galleryIndex);this.lightbox.showModal();this.querySelector('[data-gallery-close]').focus();},opts);
 this.querySelector('[data-gallery-close]').addEventListener('click',()=>this.lightbox.close(),opts);
 this.querySelector('[data-gallery-prev]').addEventListener('click',()=>this.showPhoto(this.galleryIndex-1),opts);
 this.querySelector('[data-gallery-next]').addEventListener('click',()=>this.showPhoto(this.galleryIndex+1),opts);
 this.lightbox.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.showPhoto(this.galleryIndex+(event.key==='ArrowRight'?1:-1));}},opts);
 this.lightbox.addEventListener('close',()=>{this.querySelector('[data-gallery-stage]').replaceChildren();if(this.galleryOrigin?.isConnected)this.galleryOrigin.focus({preventScroll:true});this.galleryOrigin=null;},opts);
 this.lightbox.addEventListener('click',event=>{if(event.target===this.lightbox)this.lightbox.close();},opts);
 const stage=this.querySelector('[data-gallery-stage]');
 stage.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')this.swipeStart={x:event.clientX,y:event.clientY};},opts);
 stage.addEventListener('pointerup',event=>{if(!this.swipeStart)return;const dx=event.clientX-this.swipeStart.x,dy=event.clientY-this.swipeStart.y;this.swipeStart=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.showPhoto(this.galleryIndex+(dx<0?1:-1));},opts);
 stage.addEventListener('pointercancel',()=>{this.swipeStart=null;},opts);
}
showPhoto(index){
 const total=this.galleryLinks.length;if(!total)return;this.galleryIndex=(index+total)%total;
 const link=this.galleryLinks[this.galleryIndex],source=link.querySelector('img'),photo=document.createElement('img');
 photo.src=link.href;photo.alt=source.alt;photo.draggable=false;
 this.querySelector('[data-gallery-stage]').replaceChildren(photo);
 const count=this.querySelector('[data-gallery-count]');count.textContent=count.dataset.format.replace('__current__',this.galleryIndex+1).replace('__total__',total);
 this.querySelector('[data-gallery-prev]').disabled=total<2;this.querySelector('[data-gallery-next]').disabled=total<2;
}
setCount(count){this.querySelector('[data-count]').textContent=count;const label=this.querySelector('[data-count-label]');label.textContent=count===1?label.dataset.one:label.dataset.many;}
openProject(card){if(this.active===card)return;if(this.dialog.open){this.restoreProject();}this.active=card;this.detail=card.querySelector('[data-detail]');this.holder.append(this.detail);const products=this.detail.querySelector('[data-products]');if(products)products.open=window.matchMedia('(min-width:800px)').matches;this.dialog.setAttribute('aria-labelledby',this.detail.querySelector('h2').id);if(!this.dialog.open)this.dialog.showModal();this.dialog.scrollTop=0;this.querySelector('[data-close]').focus();}
restoreProject(){if(!this.active)return;const summary=this.active.querySelector('summary');this.active.append(this.detail);this.active=null;this.detail=null;summary.focus();}
disconnectedCallback(){if(this.lightbox?.open)this.lightbox.close();if(this.dialog?.open)this.dialog.close();this.restoreProject();this.abort?.abort();this.ready=false;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-related-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rok-related-products'))customElements.define('rok-related-products',class extends HTMLElement{
  connectedCallback(){
    if(this.hasAttribute('data-curated')||this.loaded)return;
    this.loaded=true;
    this.observer=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.load()}
    },{rootMargin:'300px'});
    this.observer.observe(this);
  }
  disconnectedCallback(){this.observer?.disconnect()}
  async load(){
    try{
      const response=await fetch(this.dataset.url);
      if(!response.ok)return;
      const document=new DOMParser().parseFromString(await response.text(),'text/html');
      const result=document.getElementById(this.id);
      if(result?.querySelector('.rok-related-card'))this.innerHTML=result.innerHTML;
    }catch{}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-restocking"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rok-restocking')) {
  customElements.define('rok-restocking', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const search = this.querySelector('input[type="search"]');
      const rows = [...this.querySelectorAll('details')];
      const counter = this.querySelector('[data-count]');
      const expand = this.querySelector('[data-expand]');
      const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
      const updateExpand = () => {
        const visible = rows.filter(row => !row.hidden);
        expand.textContent = visible.length && visible.every(row => row.open) ? expand.dataset.close : expand.dataset.open;
        expand.disabled = !visible.length;
      };
      const filter = () => {
        const term = normalize(search.value);
        rows.forEach(row => { row.hidden = !normalize(row.dataset.name).includes(term); });
        const count = rows.filter(row => !row.hidden).length;
        counter.textContent = count + ' / ' + rows.length + ' ' + counter.dataset.label;
        this.querySelector('.rok-returns__empty').hidden = count > 0;
        this.querySelector('.rok-returns__columns').hidden = count === 0;
        updateExpand();
      };
      search.addEventListener('input', filter);
      this.querySelector('[data-clear]').addEventListener('click', () => { search.value = ''; filter(); search.focus(); });
      expand.addEventListener('click', () => {
        const visible = rows.filter(row => !row.hidden);
        const open = !visible.every(row => row.open);
        visible.forEach(row => { row.open = open; });
        updateExpand();
      });
      rows.forEach(row => row.addEventListener('toggle', updateExpand));
      this.onHash = () => {
        const row = rows.find(item => '#' + item.id === location.hash);
        if (!row) return;
        search.value = '';
        filter();
        row.open = true;
        row.scrollIntoView({block:'start'});
      };
      window.addEventListener('hashchange', this.onHash);
      this.querySelector('.rok-returns__tools').hidden = false;
      filter();
      this.onHash();
    }
    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHash);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-shipping-quote"]) return;
  try {
    
function initializeRokQuote(){
  document.querySelectorAll('[data-rok-quote]').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const confirmation=root.querySelector('.rok-quote__success');
    if(confirmation){confirmation.focus();confirmation.scrollIntoView({block:'center'});}
    root.querySelectorAll('[data-quote-back]').forEach(link=>link.addEventListener('click',event=>{
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(link.href);
    }));
    const form=root.querySelector('form');
    const button=root.querySelector('[data-quote-submit]');
    if(!form||!button)return;
    const error=root.querySelector('[data-quote-error]');
    const label=button.innerHTML;
    let ready=false;
    let busy=false;
    form.addEventListener('submit',async event=>{
      if(ready)return;
      event.preventDefault();
      if(busy)return;
      busy=true;
      error.hidden=true;
      button.disabled=true;
      button.textContent=root.dataset.sending;
      try{
        const response=await fetch(root.dataset.cartUrl,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error(root.dataset.fetchError);
        const cart=await response.json();
        const expected=Array.from(root.querySelectorAll('[data-quote-item]')).map(el=>[el.dataset.key,Number(el.dataset.quantity)]);
        const actual=cart.items.map(item=>[item.key,item.quantity]);
        if(!cart.items.length||JSON.stringify(expected)!==JSON.stringify(actual))throw new Error(root.dataset.changed);
        root.querySelector('[data-quote-items]').value=cart.items.map(item=>{
          const properties=Object.entries(item.properties||{}).filter(([key])=>!key.startsWith('_')).map(([key,value])=>`${key}: ${value}`).join('\n');
          return `${item.product_title} | SKU: ${item.sku||''} | Option: ${item.variant_title||'Default'} | Quantity: ${item.quantity} | Variant ID: ${item.variant_id}\n${properties}`;
        }).join('\n\n');
        ready=true;
        busy=false;
        button.disabled=false;
        button.innerHTML=label;
        form.requestSubmit(button);
        ready=false;
      }catch(err){
        error.textContent=err.message===root.dataset.changed?root.dataset.changed:root.dataset.fetchError;
        error.hidden=false;
        button.disabled=false;
        button.innerHTML=label;
        busy=false;
      }
    });
  });
}
initializeRokQuote();
document.addEventListener('shopify:section:load',initializeRokQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rok-sink-details"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rok-sink-details'))customElements.define('rok-sink-details',class extends HTMLElement{
 connectedCallback(){
  this.finishes=JSON.parse(this.querySelector('[data-finishes]').textContent);
  this.onVariant=e=>{
   const main=e.target.closest('section[data-product-handle]');
   if(main?.dataset.productHandle!==this.dataset.productHandle)return;
   const id=e.target.currentVariant?.id||main.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
   const sku=this.finishes[String(id)];
   this.querySelectorAll('[data-finish]').forEach(el=>{el.hidden=!sku||!sku.endsWith(el.dataset.finish)});
  };
  document.addEventListener('variantChangeEnd',this.onVariant);
 }
 disconnectedCallback(){document.removeEventListener('variantChangeEnd',this.onVariant)}
});

  } catch(e) { console.error(e); }
})();
})();
